import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=68dff850"
import script from "./Global.vue?vue&type=script&lang=ts"
export * from "./Global.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports